export interface Config {
    apiUrl: string;
    zendeskUrl: string;
    env: 'staging' | 'sandbox' | 'production';
    dev: boolean;
    mixpanelToken: string;
    recaptchaKey: string;
    featureToggleUrl: string;
    baseUrl: string;
}

let baseUrl = import.meta.env.BASE_URL;

if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
}

const remote = {
    apiUrl: 'https://staging-services.minds.digital/webportal-api/',
    featureToggleUrl:
        'https://staging-services.minds.digital/webportal-api/v1.0/',
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const local = {
    apiUrl: 'http://localhost:8081/api/',
    featureToggleUrl:
        'https://staging-services.minds.digital/webportal-api/v1.0/',
    // 'http://localhost:8081/api/v1.0/',
};

// eslint-disable-next-line import/no-mutable-exports
let config: Config = {
    ...remote,
    // ...local,
    zendeskUrl: '',
    env: 'staging',
    dev: import.meta.env.DEV,
    mixpanelToken: '',
    recaptchaKey: '',
    baseUrl,
};

async function loadConfig() {
    const url = import.meta.env.BASE_URL + 'assets/environment.json';

    const resp = await fetch(url);
    const env = (await resp.json()) as Partial<Config>;

    const ftApiUrl = env.featureToggleUrl || config.featureToggleUrl || '';

    config = { ...config, ...env, featureToggleUrl: ftApiUrl };

    return config;
}

export { config, loadConfig };
